import { Footer } from "~/components/Footer"

/** Space for fixed MainTabNav (~3.5rem) + iOS safe-area inset. */
export const FIXED_TAB_NAV_PADDING_CLASS =
  "pb-[calc(3.5rem+env(safe-area-inset-bottom,0px))]"

type PageShellProps = {
  children: React.ReactNode
  className?: string
  innerClassName?: string
  /** Vertically center content within the viewport (loading/onboarding screens). */
  centerContent?: boolean
  /** Reserve bottom space so content and footer clear the fixed MainTabNav. */
  fixedTabNav?: boolean
}

export function PageShell({
  children,
  className = "",
  innerClassName = "",
  centerContent = false,
  fixedTabNav = false,
}: PageShellProps) {
  const innerClasses = [
    "flex w-full flex-col items-center gap-6",
    centerContent ? "flex-1 justify-center" : "",
    innerClassName,
  ]
    .filter(Boolean)
    .join(" ")

  const mainClasses = [
    "bg-parchment-vignette bg-parchment-noise flex w-full flex-1 flex-col items-center px-4 py-8",
    className,
  ]
    .filter(Boolean)
    .join(" ")

  return (
    <main className={mainClasses}>
      <div className={innerClasses} data-testid="page-shell-content">
        {children}
      </div>
      <Footer clearFixedTabNav={fixedTabNav} />
    </main>
  )
}
